import 'css-chunksrc/client/pages/searchPage/searchResults/task/styles.scss';export default {
  "task": "_task_94ctd_2",
  "icon": "_icon_94ctd_15",
  "main": "_main_94ctd_22",
  "header": "_header_94ctd_26",
  "name": "_name_94ctd_34",
  "zone": "_zone_94ctd_39",
  "project": "_project_94ctd_46",
  "projectIcon": "_projectIcon_94ctd_54",
  "projectName": "_projectName_94ctd_62",
  "match": "_match_94ctd_68",
  "footer": "_footer_94ctd_72"
};